import { atom } from "recoil";
import { News } from "../../models";

export const withNews = atom({
    key: 'withNews',
    default: [] as News[]
})